export default __webpack_public_path__ + "./images/vkid.97843680.svg";